import { Button, Input } from "@light-technology/components";
import { Copy01 } from "@untitledui/icons";
import { api } from "../../state/api";
import { type AppResponse } from "../../state/api.types";
import { NewTabLink } from "../shared/NewTabLink";

type StandaloneCardProps = {
  app: AppResponse;
};

export const StandaloneCard = (props: StandaloneCardProps) => {
  const getStandalone = api.useGetStandaloneQuery(props.app.uuid);

  return (
    <div className="rounded-xl border border-secondary p-3xl">
      <div className="text-lg font-semibold">No-code web app</div>
      <div className="text-sm text-tertiary">
        Customers can access a standalone, prebuilt plan experience. Reach out
        to have this configured.
      </div>
      <div className="mt-3xl flex items-center gap-md">
        <Input
          isRequired
          isDisabled
          label="Configured domain"
          value={getStandalone.data?.custom_domain ?? undefined}
          hint="This is the domain your DNS points to."
        />
        <Button
          color="tertiary"
          tooltip="Copy configured domain"
          tooltipOnClick="Domain copied to clipboard"
          iconLeading={Copy01}
          onClick={() => {
            if (getStandalone.data?.custom_domain) {
              navigator.clipboard.writeText(getStandalone.data.custom_domain);
            }
          }}
          isDisabled={!getStandalone.data?.custom_domain}
        />
      </div>
      <div className="mt-3xl flex items-center gap-md">
        <Input
          isRequired
          isDisabled
          label="Customer URL"
          value={getStandalone.data?.url}
          hint="Share this link with your customers to access the no-code web app."
        />
        <Button
          color="tertiary"
          tooltip="Copy customer URL"
          tooltipOnClick="URL copied to clipboard"
          iconLeading={Copy01}
          onClick={() => {
            if (getStandalone.data?.url) {
              navigator.clipboard.writeText(getStandalone.data.url);
            }
          }}
          isDisabled={!getStandalone.data?.url}
        />
        <NewTabLink link={getStandalone.data?.url} />
      </div>
    </div>
  );
};
